/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, unit: NonNullable<unknown> }} Task_Days_In_ProgressInputs */

const en_task_days_in_progress = /** @type {(inputs: Task_Days_In_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} ${i?.unit} in progress`)
};

const pt_br2_task_days_in_progress = /** @type {(inputs: Task_Days_In_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} ${i?.unit} em andamento`)
};

/**
* | output |
* | --- |
* | "{days} {unit} in progress" |
*
* @param {Task_Days_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_days_in_progress = /** @type {((inputs: Task_Days_In_ProgressInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Days_In_ProgressInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_days_in_progress(inputs)
	return pt_br2_task_days_in_progress(inputs)
});